import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useBreakpointDown } from '@travel-frontend/core';
import { RatingDeclarations } from '../../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingDeclarations/index.js';
import { Label } from '../../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/Summary/components/Label.js';
import { RatingBadge, Tooltip } from '../../../../../../../primitives/index.js';
export const Badge = ({
  score,
  scoreMax,
  sentiment
}) => {
  const smDown = useBreakpointDown('sm');
  return smDown ? _jsx(RatingBadge, {
    variant: "vertical",
    sentiment: sentiment,
    withIcon: false,
    style: {
      width: 42,
      height: 42
    },
    children: _jsxs(Label, {
      children: [score, "/", scoreMax]
    })
  }) : _jsx(Tooltip, {
    tooltipText: "Amadeus rating scores",
    tooltipElement: "AmaRatingBadge",
    content: _jsx(RatingDeclarations, {}),
    children: _jsx(RatingBadge, {
      variant: "vertical",
      sentiment: sentiment,
      withIcon: false,
      style: {
        width: 74,
        height: 74
      },
      children: _jsxs(Label, {
        children: [score, "/", scoreMax]
      })
    })
  });
};